// eslint-disable no-use-before-define
// eslint-disable react/prop-types
import React, { Fragment, useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router';
import { Link as RouterLink } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import PerfectScrollbar from 'react-perfect-scrollbar';
import PropTypes from 'prop-types';
import {
  Avatar,
  Box,
  Divider,
  Drawer,
  Hidden,
  Link,
  List,
  ListSubheader,
  Typography,
  Button,
  makeStyles,
  Collapse,
  ListItemIcon,
  ListItemText
  // ListItemButton
} from '@material-ui/core';
import {
  ArrowDown,
  ArrowRight,
  Bookmark,
  Clipboard,
  Folder,
  LogOut,
  RefreshCw,
  // Settings,
  User
} from 'react-feather';
import Logo from 'src/components/Logo';
import { useSnackbar } from 'notistack';
import { logout } from 'src/actions/accountActions';

// import NavItem from './NavItem';

// function NavList({ items, ...rest }) {
//   const [expandedItem, setExpandedItem] = useState(null);

//   const handleToggle = item => {
//     // console.log('ITEM: ', item);
//     setExpandedItem(item);
//   };

//   return (
//     <List disablePadding>
//       {items.reduce(
//         (acc, item) =>
//           reduceChildRoutes({ acc, item, handleToggle, expandedItem, ...rest }),
//         []
//       )}
//     </List>
//   );
// }

// function reduceChildRoutes({
//   acc,
//   item,
//   depth = 0,
//   handleToggle,
//   expandedItem
// }) {
//   const key = item.title + depth;

//   acc.push(
//     <React.Fragment key={key}>
//       <NavItem
//         style={{
//           display: 'block'
//         }}
//         depth={depth}
//         href={item.href}
//         icon={item.icon}
//         title={item.title}
//         enabled={item.enabled}
//         onClick={() => {
//           handleToggle(item);
//         }}
//       />
//       {console.log(
//         'expandedItem !== null && expandedItem.titled === item.title: ',
//         expandedItem !== null && expandedItem.title === item.title
//       )}
//       <Collapse
//         in={expandedItem !== null && expandedItem.title === item.title}
//         timeout="auto"
//         unmountOnExit
//       >
//         qwe
//       </Collapse>
//     </React.Fragment>
//   );

//   return acc;
// }

const imageLocation = process.env.REACT_APP_IMAGE;

const useStyles = makeStyles(() => ({
  mobileDrawer: {
    width: 256
  },
  desktopDrawer: {
    width: 256,
    top: 64,
    height: 'calc(100% - 64px)'
  },
  avatar: {
    cursor: 'pointer',
    width: 64,
    height: 64
  }
}));

function NavBar({ openMobile, onMobileClose }) {
  const classes = useStyles();
  const location = useLocation();
  const { user } = useSelector(state => state.account);
  const [selectedNav, setSelectedNav] = useState(null);
  const [selectedNav2, setSelectedNav2] = useState(null);
  const dispatch = useDispatch();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();

  // console.log('path: ', '/admin/collection-type');
  // console.log('WINDOW: ', window.location.pathname);

  const navConfig = [
    //admin
    {
      subheader: '',
      owner: 'Admin',
      items: [
        {
          title: 'Transaction',
          icon: Clipboard,
          enabled: true,
          items: [
            {
              id: 1,
              title: 'Collection',
              path: null,
              items: [
                {
                  id: 1,
                  title: 'Issuance of Official Receipt(OR)',
                  path:
                    '/admin/transaction/collection/issuance-official-receipt'
                },
                {
                  id: 2,
                  title: 'Business Permit(OR)',
                  path: '/admin/transaction/collection/business-permit'
                },
                {
                  id: 3,
                  title: 'Building Permit(OR)',
                  path: '/admin/transaction/collection/building-permit'
                },
                {
                  id: 3,
                  title: 'Community Tax Certificate(CTC) - Ind',
                  path: '/admin/transaction/collection/ctc-ind'
                },
                {
                  id: 4,
                  title: 'Community Tax Certificate(CTC) - Corp',
                  path: '/admin/transaction/collection/ctc-corp'
                },
                {
                  id: 5,
                  title: 'Burial Permit and Fee Receipt',
                  path:
                    '/admin/transaction/collection/burial-permit-fee-receipt'
                },
                {
                  id: 7,
                  title: 'Real Property Tax',
                  path: '/admin/transaction/collection/rptis'
                },
                {
                  id: 8,
                  title: 'Online Request',
                  path: '/admin/transaction/collection/online-request'
                }
                // {
                //   id: 9,
                //   title: 'Report',
                //   path: '/admin/transaction/collection/report'
                // }
              ]
            },
            {
              id: 2,
              title: 'Disbursement',
              path: null,
              items: [
                {
                  id: 1,
                  title: 'Disbursement Voucher(DV)',
                  path: '/admin/transaction/disbursement/disbursement-voucher'
                }
              ]
            }
          ]
        },
        {
          title: 'Referential',
          icon: Bookmark,
          enabled: true,
          items: [
            {
              id: 1,
              title: 'Fund',
              path: null,
              items: [
                {
                  id: 1,
                  title: 'Fund Group',
                  path: '/admin/referential/fund/fund-group'
                },
                {
                  id: 2,
                  title: 'Fund Code',
                  path: '/admin/referential/fund/fund-code'
                }
              ]
            },
            {
              id: 2,
              title: 'Allotment',
              path: null,
              items: [
                {
                  id: 1,
                  title: 'Allotment Code',
                  path: '/admin/referential/allotment/allotment-code'
                },
                {
                  id: 2,
                  title: 'Allotment Class',
                  path: '/admin/referential/allotment/allotment-class'
                }
              ]
            },
            {
              id: 3,
              title: 'FPP',
              path: null,
              items: [
                {
                  id: 1,
                  title: 'Function Code',
                  path: '/admin/referential/fpp/function-code'
                },
                {
                  id: 2,
                  title: 'Program Code',
                  path: '/admin/referential/fpp/program-code'
                },
                {
                  id: 3,
                  title: 'FPP Code',
                  path: '/admin/referential/fpp/fpp-code'
                }
              ]
            },
            {
              id: 4,
              title: 'Chart Of Accounts',
              path: null,
              items: [
                {
                  id: 1,
                  title: 'Account Code',
                  path: '/admin/referential/chart-accounts/account-code'
                },
                {
                  id: 2,
                  title: 'Object Code',
                  path: '/admin/referential/chart-accounts/object-code'
                }
              ]
            },
            {
              id: 6,
              title: 'Accountability',
              path: null,
              items: [
                {
                  id: 1,
                  title: 'Accountable Forms',
                  path: '/admin/referential/accountability/accountable-forms'
                },
                {
                  id: 2,
                  title: 'Check Booklets',
                  path: '/admin/referential/accountability/check-booklets'
                },
                {
                  id: 3,
                  title: 'Bank Depository',
                  path: '/admin/referential/accountability/bank-depository'
                },
                {
                  id: 4,
                  title: 'Form Code',
                  path: '/admin/referential/accountability/form-code'
                },
                {
                  id: 5,
                  title: 'Officer Type',
                  path: '/admin/referential/accountability/officer-type'
                },
                {
                  id: 6,
                  title: 'LiqDisb Collector',
                  path: '/admin/referential/accountability/liq-disb-collector'
                },
                {
                  id: 7,
                  title: 'Cost Center',
                  path: '/admin/referential/accountability/cost-center'
                },
                {
                  id: 8,
                  title: 'Creditor/Payee',
                  path: '/admin/referential/accountability/creditor-payee'
                },
                {
                  id: 9,
                  title: 'OR Template',
                  path: '/admin/referential/accountability/or-template'
                },
                {
                  id: 10,
                  title: 'Accountant',
                  path: '/admin/referential/accountability/accountant'
                },
                {
                  id: 11,
                  title: 'Treasurer',
                  path: '/admin/referential/accountability/treasurer'
                },
                {
                  id: 12,
                  title: 'Mayor',
                  path: '/admin/referential/accountability/mayor'
                }
              ]
            },
            {
              id: 7,
              title: 'Collection Type',
              path: '/admin/collection-type'
            },
            {
              id: 8,
              title: 'Cemetery',
              path: '/admin/referential/cemetery'
            }
          ]
        },
        {
          title: 'Process',
          icon: RefreshCw,
          enabled: true,
          items: [
            {
              id: 1,
              title: 'Report of Collection and Deposits(RCD) Processing',
              path: '/admin/process/rcd-processing'
            },
            {
              id: 2,
              title:
                'Report of Collection by Liquidating Officer(RCLO) Processing',
              path: '/admin/process/rclo-processing'
            }
          ]
        },
        {
          title: 'Reports',
          icon: Folder,
          enabled: true,
          items: [
            {
              id: 1,
              title: 'Accountable Forms',
              path: null,
              items: [
                {
                  id: 1,
                  title: 'Report of Accountability for Accountable Forms',
                  path:
                    '/admin/reports/accountable-forms/report-accountability-accountable-forms'
                },
                {
                  id: 2,
                  title:
                    'Consolidated Report of Accountability for Accountable Forms',
                  path:
                    '/admin/reports/accountable-forms/consolidated-report-accountability-accountable-forms'
                }
              ]
            },
            {
              id: 2,
              title: 'Collection',
              path: null,
              items: [
                {
                  id: 1,
                  title: 'Abstract of Collection',
                  path: '/admin/reports/collection/abstract-collection'
                }
              ]
            },
            {
              id: 3,
              title: 'Report of Collection and Deposit(RCD)',
              path: '/admin/reports/rcd'
            },
            {
              id: 4,
              title: 'Report of Collection by Liquidating Officer(RCLO)',
              path: '/admin/reports/rclo'
            }
          ]
        },
        {
          title: 'Admin',
          icon: User,
          enabled: true,
          items: [
            {
              id: 1,
              title: 'Users',
              path: '/admin/users'
            },
            {
              id: 2,
              title: 'Roles',
              path: '/admin/roles'
            },
            {
              id: 3,
              title: 'Public OR Template',
              path: '/admin/group-template'
            }
          ]
        }
      ]
    },
    //cashier
    {
      subheader: '',
      owner: 'Cashier',
      items: [
        {
          id: 1,
          title: 'Collection',
          path: null,
          items: [
            {
              id: 1,
              title: 'Issuance of Official Receipt(OR)',
              path: '/admin/transaction/collection/issuance-official-receipt'
            },
            {
              id: 2,
              title: 'Business Permit(OR)',
              path: '/admin/transaction/collection/business-permit'
            },
            {
              id: 8,
              title: 'Building Permit(OR)',
              path: '/admin/transaction/collection/building-permit'
            },
            {
              id: 3,
              title: 'Community Tax Certificate(CTC) - Ind',
              path: '/admin/transaction/collection/ctc-ind'
            },
            {
              id: 4,
              title: 'Community Tax Certificate(CTC) - Corp',
              path: '/admin/transaction/collection/ctc-corp'
            },
            {
              id: 5,
              title: 'Burial Permit and Fee Receipt',
              path: '/admin/transaction/collection/burial-permit-fee-receipt'
            },
            {
              id: 6,
              title: 'Real Property Tax',
              path: '/admin/transaction/collection/rptis'
            },
            {
              id: 7,
              title: 'Online Request',
              path: '/admin/transaction/collection/online-request'
            }

            // {
            //   id: 7,
            //   title: 'Report',
            //   path: '/admin/transaction/collection/report'
            // }
          ]
        },
        {
          title: 'Process',
          icon: RefreshCw,
          enabled: true,
          items: [
            {
              id: 1,
              title: 'Report of Collection and Deposits(RCD) Processing',
              path: '/admin/process/rcd-processing'
            },
            {
              id: 2,
              title:
                'Report of Collection by Liquidating Officer(RCLO) Processing',
              path: '/admin/process/rclo-processing'
            }
          ]
        },
        {
          title: 'Reports',
          icon: Folder,
          enabled: true,
          items: [
            {
              id: 1,
              title: 'Accountable Forms',
              path: null,
              items: [
                {
                  id: 1,
                  title: 'Report of Accountability for Accountable Forms',
                  path:
                    '/admin/reports/accountable-forms/report-accountability-accountable-forms'
                },
                {
                  id: 2,
                  title:
                    'Consolidated Report of Accountability for Accountable Forms',
                  path:
                    '/admin/reports/accountable-forms/consolidated-report-accountability-accountable-forms'
                }
              ]
            },
            {
              id: 2,
              title: 'Collection',
              path: null,
              items: [
                {
                  id: 1,
                  title: 'Abstract of Collection',
                  path: '/admin/reports/collection/abstract-collection'
                }
              ]
            },
            {
              id: 3,
              title: 'Report of Collection and Deposit(RCD)',
              path: '/admin/reports/rcd'
            },
            {
              id: 4,
              title: 'Report of Collection by Liquidating Officer(RCLO)',
              path: '/admin/reports/rclo'
            }
          ]
        }
      ]
    },
    //af issuer
    {
      subheader: '',
      owner: 'AF Issuer',
      items: [
        {
          title: 'Referential',
          icon: Bookmark,
          enabled: true,
          items: [
            {
              id: 1,
              title: 'Fund',
              path: null,
              items: [
                {
                  id: 1,
                  title: 'Fund Group',
                  path: '/admin/referential/fund/fund-group'
                },
                {
                  id: 2,
                  title: 'Fund Code',
                  path: '/admin/referential/fund/fund-code'
                }
              ]
            },
            {
              id: 2,
              title: 'Allotment',
              path: null,
              items: [
                {
                  id: 1,
                  title: 'Allotment Code',
                  path: '/admin/referential/allotment/allotment-code'
                },
                {
                  id: 2,
                  title: 'Allotment Class',
                  path: '/admin/referential/allotment/allotment-class'
                }
              ]
            },
            {
              id: 3,
              title: 'FPP',
              path: null,
              items: [
                {
                  id: 1,
                  title: 'Function Code',
                  path: '/admin/referential/fpp/function-code'
                },
                {
                  id: 2,
                  title: 'Program Code',
                  path: '/admin/referential/fpp/program-code'
                },
                {
                  id: 3,
                  title: 'FPP Code',
                  path: '/admin/referential/fpp/fpp-code'
                }
              ]
            },
            {
              id: 4,
              title: 'Chart Of Accounts',
              path: null,
              items: [
                {
                  id: 1,
                  title: 'Account Code',
                  path: '/admin/referential/chart-accounts/account-code'
                },
                {
                  id: 2,
                  title: 'Object Code',
                  path: '/admin/referential/chart-accounts/object-code'
                }
              ]
            },
            {
              id: 6,
              title: 'Accountability',
              path: null,
              items: [
                {
                  id: 1,
                  title: 'Accountable Forms',
                  path: '/admin/referential/accountability/accountable-forms'
                },
                {
                  id: 2,
                  title: 'Check Booklets',
                  path: '/admin/referential/accountability/check-booklets'
                },
                {
                  id: 3,
                  title: 'Bank Depository',
                  path: '/admin/referential/accountability/bank-depository'
                },
                {
                  id: 4,
                  title: 'Form Code',
                  path: '/admin/referential/accountability/form-code'
                },
                {
                  id: 5,
                  title: 'Officer Type',
                  path: '/admin/referential/accountability/officer-type'
                },
                {
                  id: 6,
                  title: 'LiqDisb Collector',
                  path: '/admin/referential/accountability/liq-disb-collector'
                },
                {
                  id: 7,
                  title: 'Cost Center',
                  path: '/admin/referential/accountability/cost-center'
                },
                {
                  id: 8,
                  title: 'Creditor/Payee',
                  path: '/admin/referential/accountability/creditor-payee'
                },
                {
                  id: 9,
                  title: 'OR Template',
                  path: '/admin/referential/accountability/or-template'
                }
              ]
            },
            {
              id: 7,
              title: 'Collection Type',
              path: '/admin/collection-type'
            },
            {
              id: 8,
              title: 'Cemetery',
              path: '/admin/referential/cemetery'
            }
          ]
        }
      ]
    },
    //brgy treasurer
    {
      subheader: '',
      owner: 'Brgy Treasurer',
      items: [
        {
          id: 1,
          title: 'Collection',
          path: null,
          items: [
            {
              id: 1,
              title: 'Community Tax Certificate(CTC) - Ind',
              path: '/admin/transaction/collection/ctc-ind'
            }
          ]
        }
      ]
    },
    //disbursing officer
    {
      subheader: '',
      owner: 'Disbursing Officer',
      items: [
        {
          title: 'Transaction',
          icon: Clipboard,
          enabled: true,
          items: [
            {
              id: 1,
              title: 'Disbursement',
              path: null,
              items: [
                {
                  id: 1,
                  title: 'Disbursement Voucher(DV)',
                  path: '/admin/transaction/disbursement/disbursement-voucher'
                }
              ]
            }
          ]
        },
        {
          title: 'Referential',
          icon: Bookmark,
          enabled: true,
          items: [
            {
              id: 1,
              title: 'Accountability',
              path: null,
              items: [
                {
                  id: 1,
                  title: 'Check Booklets',
                  path: '/admin/referential/accountability/check-booklets'
                },
                {
                  id: 2,
                  title: 'Creditor/Payee',
                  path: '/admin/referential/accountability/creditor-payee'
                },
                {
                  id: 3,
                  title: 'Bank Depository',
                  path: '/admin/referential/accountability/bank-depository'
                },
                {
                  id: 4,
                  title: 'Accountant',
                  path: '/admin/referential/accountability/accountant'
                },
                {
                  id: 5,
                  title: 'Treasurer',
                  path: '/admin/referential/accountability/treasurer'
                },
                {
                  id: 6,
                  title: 'Mayor',
                  path: '/admin/referential/accountability/mayor'
                }
              ]
            }
          ]
        }
      ]
    }
  ];

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
    // eslint-disable-next-line
  }, [location.pathname]);

  const handleLogout = () => {
    try {
      // handleClose();
      dispatch(logout());
      history.push('/');
    } catch (error) {
      enqueueSnackbar('Unable to logout', {
        variant: 'error'
      });
    }
  };

  const content = (
    <Box
      height="100%"
      display="flex"
      flexDirection="column"
      // style={{ backgroundColor: '#121212' }}
    >
      <PerfectScrollbar options={{ suppressScrollX: true }}>
        <Hidden lgUp>
          <Box p={2} display="flex" justifyContent="center">
            <RouterLink to="/">
              <Logo />
            </RouterLink>
          </Box>
        </Hidden>
        <Box p={2}>
          <Box display="flex" justifyContent="center">
            <RouterLink
              to={
                user.roles[0].name.trim() === 'admin'
                  ? '/admin/account'
                  : '/patient/account'
              }
            >
              <Avatar
                alt={user.firstname}
                className={classes.avatar}
                src={`${imageLocation}avatar/${user.avatar}`}
              />
            </RouterLink>
          </Box>
          <Box mt={2} textAlign="center">
            <Link
              component={RouterLink}
              to={
                user.roles[0].name.trim() === 'admin'
                  ? '/admin/account'
                  : '/patient/account'
              }
              variant="h5"
              color="textPrimary"
              underline="none"
            >
              {`${user.firstname} ${user.lastname}`}
            </Link>
            <Typography variant="body2" color="textSecondary">
              {user.email}
            </Typography>
          </Box>
        </Box>
        <Divider />

        {navConfig
          .filter(x => user.roles[0].name.trim() === x.owner)
          .map((config, index) => (
            <Box key={index}>
              <List
                style={{
                  width: '100%'
                }}
                subheader={
                  <ListSubheader
                    disableGutters
                    disableSticky
                    style={{
                      color: 'rgba(255,255,255,0.6)',
                      fontSize: '12px',
                      fontWeight: 600,
                      textTransform: 'uppercase',
                      letterSpacing: '1px',
                      padding: '16px 16px 8px 16px'
                    }}
                  >
                    {config.subheader}
                  </ListSubheader>
                }
                component="nav"
              >
                {config.items.map((item, index2) => (
                  <Fragment key={index2}>
                    <Box p={1}>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          gap: 10,
                          padding: 2,
                          cursor: 'pointer'
                        }}
                        onClick={() => {
                          setSelectedNav(prevState =>
                            prevState === item.title ? null : item.title
                          );
                          setSelectedNav2(null);
                        }}
                      >
                        <ListItemText primary={`${item.title}`} />
                        <ListItemIcon>
                          {item.title === selectedNav ? (
                            <ArrowDown size={15} />
                          ) : (
                            <ArrowRight size={15} />
                          )}
                        </ListItemIcon>
                      </div>
                      <Collapse
                        in={selectedNav !== null && selectedNav === item.title}
                        timeout="auto"
                        unmountOnExit
                      >
                        {item.items &&
                          item.items.length > 0 &&
                          item.items.map((data, key) => (
                            <Fragment key={key}>
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  gap: 10,
                                  padding: 2,
                                  cursor: 'pointer',
                                  // border: '1px solid blue',
                                  backgroundColor:
                                    window.location.pathname === data.path
                                      ? '#262f37'
                                      : 'inherit',
                                  borderRadius: 8,
                                  minHeight: 45
                                }}
                                onClick={() => {
                                  if (data.path !== null) {
                                    history.push(data.path);
                                    setSelectedNav2(null);
                                  } else {
                                    setSelectedNav2(prevState =>
                                      prevState === data.title
                                        ? null
                                        : data.title
                                    );
                                  }
                                }}
                                onContextMenu={e => {
                                  // Check if item id is 1-6 and has a path
                                  if (
                                    data.id >= 1 &&
                                    data.id <= 6 &&
                                    data.path
                                  ) {
                                    e.preventDefault();
                                    const fullUrl = `${window.location.origin}${data.path}`;
                                    window.open(fullUrl, '_blank');
                                  }
                                }}
                              >
                                <ListItemText
                                  primary={data.title}
                                  primaryTypographyProps={{
                                    style: {
                                      fontSize: 15,
                                      fontStyle: 'italic',
                                      marginLeft: 15,
                                      color:
                                        window.location.pathname === data.path
                                          ? '#42a5f5'
                                          : 'inherit'
                                    }
                                  }}
                                />
                                <ListItemIcon>
                                  {data.path !== null ? null : data.title ===
                                    selectedNav2 ? (
                                    <ArrowDown size={15} />
                                  ) : (
                                    <ArrowRight size={15} />
                                  )}
                                </ListItemIcon>
                              </div>

                              <Collapse
                                in={
                                  selectedNav2 !== null &&
                                  selectedNav2 === data.title
                                }
                                timeout="auto"
                                unmountOnExit
                              >
                                {data.items &&
                                  data.items.length > 0 &&
                                  data.items.map((data2, key2) => (
                                    <Fragment key={key2}>
                                      <div
                                        style={{
                                          display: 'flex',
                                          justifyContent: 'center',
                                          alignItems: 'center',
                                          gap: 10,
                                          padding: 2,
                                          cursor: 'pointer',
                                          // border: '1px solid red',
                                          backgroundColor:
                                            window.location.pathname ===
                                            data2.path
                                              ? '#262f37'
                                              : 'inherit',
                                          borderRadius: 8,
                                          minHeight: 45
                                        }}
                                        onClick={() => {
                                          history.push(data2.path);
                                        }}
                                        onContextMenu={e => {
                                          // Check if item id is 1-6 and has a path
                                          if (
                                            data2.id >= 1 &&
                                            data2.id <= 6 &&
                                            data2.path
                                          ) {
                                            e.preventDefault();
                                            const fullUrl = `${window.location.origin}${data2.path}`;
                                            window.open(fullUrl, '_blank');
                                          }
                                        }}
                                      >
                                        <ListItemText
                                          primary={data2.title}
                                          primaryTypographyProps={{
                                            style: {
                                              fontSize: 14,
                                              marginLeft: 30,
                                              color:
                                                window.location.pathname ===
                                                data2.path
                                                  ? '#42a5f5'
                                                  : 'inherit'
                                            }
                                          }}
                                        />
                                      </div>
                                    </Fragment>
                                  ))}
                              </Collapse>
                            </Fragment>
                          ))}
                      </Collapse>
                    </Box>
                    <Box>
                      <Divider />
                    </Box>
                  </Fragment>
                ))}
              </List>
            </Box>
          ))}

        <Box p={2}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: 10,
              padding: 2,
              cursor: 'pointer'
              // marginTop: 10
            }}
            onClick={handleLogout}
          >
            <ListItemIcon>
              <LogOut />
            </ListItemIcon>
            <ListItemText primary={'Exit'} />
          </div>
        </Box>
        <Divider />
        <Hidden xsUp xsDown>
          <Box p={1}>
            <Box p={2} borderRadius="borderRadius" bgcolor="background.dark">
              <Typography variant="h6" color="textSecondary" align="center">
                To register your property? Click{' '}
              </Typography>

              <Box mt={1}>
                <Button
                  size="small"
                  variant="contained"
                  color="primary"
                  component={RouterLink}
                  to="/app/property/register"
                  fullWidth
                >
                  {' '}
                  Register{' '}
                </Button>
              </Box>
            </Box>
          </Box>
        </Hidden>
      </PerfectScrollbar>
    </Box>
  );

  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          classes={{ paper: classes.mobileDrawer }}
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
        >
          {content}
        </Drawer>
      </Hidden>
      <Hidden mdDown>
        <Drawer
          anchor="left"
          classes={{ paper: classes.desktopDrawer }}
          open
          variant="persistent"
        >
          {content}
        </Drawer>
      </Hidden>
    </>
  );
}

NavBar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool
};

export default NavBar;
